import React, { useEffect, useState } from "react"

import { Autocomplete, TextField } from '@mui/material';
import { getOptionSelect } from "../../Services/OptionSelect";


export default function SelectForm({ data, handleChange, dependencyFilter, valueField }) {

    const [option, setOption] = useState([])
    const [dataAll, setDataAll] = useState([])

    const [numberRegister,] = useState(10)

    const [clearState, setClearState] = useState(false)

    async function getData() {
        if (data.tipo === "tabla") {
            await getOptionSelect(data.servicio, data.filtro).then(async response => {
                const dataFull = response.data
                setDataAll(dataFull)
                setOption(dataFull.slice(0, numberRegister))
            })
        } else {
            const dataFull = data.opciones
            setDataAll(dataFull)
            setOption(dataFull)
        }

    }

    useEffect(() => {
        getData()
    }, [])

    async function filterItemByOtherField(returnInfo) {
        const dataFilter = dependencyFilter?.[data.id];
        //const dataFilterOther = dataAll.filter(item => item[dataFilter?.key] === dataFilter?.value)
        const dataFilterOther = dataAll.filter(item => {
            let condicion = true
            dataFilter.map(itemData => {
                if (item[itemData.key] !== itemData.value) condicion = false
            })
            if (condicion) {
                return item
            }
        })

        if (returnInfo) return dataFilterOther
        setOption(dataFilterOther.slice(0, numberRegister))
    }

    useEffect(() => {
        if (dependencyFilter?.[data.id]) {
            filterItemByOtherField()
        }
    }, [dependencyFilter, dataAll])


    const filterItem = async (e) => {
        if (!e) return
        let fullData = dataAll
        if (dependencyFilter?.[data.id] && dependencyFilter?.[data.id]?.length > 0) {
            fullData = await filterItemByOtherField(true)
        }
        const dataResult = fullData?.filter(item => item.opcion?.toUpperCase().includes(e?.toUpperCase()))
        setOption(dataResult.slice(0, numberRegister))
    }

    const updateClearState = () => {
        if (clearState) {
            setClearState(false)
        }
    }
    const getKeyUpdate = () => {
        if (clearState && (Object.keys(valueField).length === 0  ||  valueField[data.id] === null)) {
            return (Math.random() * 1000)
        }
        //return 1
    }
    const setItemOnFocus = () => {
        if (option.length === 0) {
            filterItemByOtherField()
        }
    }

    return (
        <>
            <Autocomplete
                key={getKeyUpdate()}
                id={"combo-box-demo" + data.id}
                options={option}
                onInputChange={e => filterItem(e.target.value)}
                getOptionLabel={(option) => option.opcion}
                onChange={(event, newValue) => {
                    setClearState(true)
                    handleChange(newValue?.id, data.id,)
                }}
                onOpen={setItemOnFocus}
                renderInput={(params) => {

                    return (
                        <TextField
                            onFocus={updateClearState}

                            {...params} label={data.item + (data?.obligatorio ? " *" : "")}

                        />
                    )
                }
                }
            />
        </>

    )
}